import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@wkda/styleguide';
import * as styles from './SelectionModeButton.module.scss';
export function SelectionModeButton({ content, onClick, isInSelectionMode, }) {
    const qaSelector = isInSelectionMode
        ? 'gdpr-banner-accept-selected-button'
        : 'gdpr-banner-configuration-button';
    return (_jsx(Button, { variant: "link", onClick: onClick, className: styles.selectionModeButton, "data-qa-selector": qaSelector, children: isInSelectionMode ? content.selection : content.default }));
}
